import { createSlice } from "@reduxjs/toolkit";
 // this code for slice value for AlgoList
export const AlgoList = createSlice({
  name: "AlgoList",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    data: [],
  },
  reducers: {
    list_AlgoList: (state, action?) => {
      state.isLoading = true;
    },
    success_api_call_AlgoList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
    },
    failure_api_call_AlgoList: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
    },
    AlgoList_is_first: (state, action) => {
      state.isFirst = false;
    },
    clearData: (state) => {
      state.data = [];
    },
  },
});
export default AlgoList.reducer;
export const {
  list_AlgoList,
  success_api_call_AlgoList,
  failure_api_call_AlgoList,
  AlgoList_is_first,
  clearData,
} = AlgoList.actions;
